import React from 'react';
import { BaseConfigProps, commonStyles } from '../shared/ConfigFormHelpers';

const AITextGeneratorConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <div>
        <label className={commonStyles.label}>
          AI Provider
        </label>
        <select
          value={node.data.config?.provider || 'openai'}
          onChange={(e) => updateConfig('provider', e.target.value)}
          className={commonStyles.select}
        >
          <option value="openai">OpenAI</option>
          <option value="claude">Claude</option>
          <option value="gemini">Gemini</option>
        </select>
      </div>

      <div>
        <label className={commonStyles.label}>
          Szöveg Típus
        </label>
        <select
          value={node.data.config?.textType || 'article'}
          onChange={(e) => updateConfig('textType', e.target.value)}
          className={commonStyles.select}
        >
          <option value="article">Cikk</option>
          <option value="email">Email</option>
          <option value="social_post">Social Media Post</option>
          <option value="product_description">Termékleírás</option>
          <option value="blog_post">Blog Bejegyzés</option>
        </select>
      </div>

      <div>
        <label className={commonStyles.label}>
          Téma
        </label>
        <input
          type="text"
          value={node.data.config?.topic || ''}
          onChange={(e) => updateConfig('topic', e.target.value)}
          placeholder="Milyen témában generáljunk szöveget?"
          className={commonStyles.input}
        />
      </div>

      <div>
        <label className={commonStyles.label}>
          Hossz
        </label>
        <select
          value={node.data.config?.length || 'medium'}
          onChange={(e) => updateConfig('length', e.target.value)}
          className={commonStyles.select}
        >
          <option value="short">Rövid (100-200 szó)</option>
          <option value="medium">Közepes (300-500 szó)</option>
          <option value="long">Hosszú (800-1000 szó)</option>
        </select>
      </div>
    </div>
  );
};

export default AITextGeneratorConfig;
